import React from 'react';
import Notification from '../Notification.js';
import axios from 'axios';


class Preview extends React.Component {
    constructor(props) {
        super(props);   

        this.state = {
            mode:'mobile',
            email:'',
            html:'',
        }     

        this.changeEmail = this.changeEmail.bind(this);
        this.sendTest = this.sendTest.bind(this);
    }

    changeEmail(e) {
       this.setState({'email':e.target.value});
    }

    sendTest(e) {
        Notification.clear();
        if(this.state.email == '') {
            Notification.error('E-mail can\'t be empty')
            return;
        }
        Notification.info('Sending email...');

        axios.post('/emails/'+this.props.id+'/test',{'email':this.state.email})
        .then((response) => {
            Notification.clear();
            Notification.success(<span>E-mail sent to <span style={{fontWeight:'300'}}>{this.state.email}</span></span>);
        })
        .catch((error) => {
            Notification.clear();
            Notification.error(error.message);
        });


        
    }

    componentDidUpdate() {
        this.refs.previewer.contentWindow.document.open();
        this.refs.previewer.contentWindow.document.write(this.state.html);
        this.refs.previewer.contentWindow.document.close();
    }


    componentDidMount() {
        $(this.refs.modal).modal('show');

        axios.get('/emails/'+this.props.id+'/preview')
        .then(res => {
            this.setState({'html':res.data});
        });
    }

    preview() {
        if(this.state.mode == 'desktop') {
            return  <div className="col-sm-12"><iframe ref="previewer" style={{border:'1px solid #ccc',width:'100%',height:'610px'}} /></div>;
        }else{
            return  (
                <div className="col-sm-12">
                    <img style={{zIndex:'2',left: "50%",transform: "translate(-50%, 0)",position:'absolute'}} src="/images/builder/phone.png" />
                    <iframe ref="previewer" style={{zIndex:'3',top:'60px',marginLeft:'0px',left: "50%",transform: "translate(-50%, 0)",position:'absolute',border:'1px solid #979797',width:'326px',height:'507px'}} />
                <div className="clearfix"></div></div>
            );
        }
    }

    switch(mode) {
        this.setState({mode:mode});
    }


    render() {
        
        return (
            <div ref="modal" className="modal fade modal-fade-in-scale-up" id="aaa" aria-hidden="true" role="dialog" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content" style={{height:'1000px'}}>
                        <div className="modal-header">
                            <button type="button" onClick={(e) => {e.stopPropagation();this.props.displayPreview()}} className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">Preview</h4>
                        </div>
                        <div className="modal-body">



                        <div className="panel panel-bordered" style={{border:' 1px solid #e4eaec'}}>
                            <div className="panel-body">
                                <div className="col-sm-9 p-0">
                                <div className="input-group input-group-icon">
                                    <span className="input-group-addon">
                                      <span className="icon wb-envelope" aria-hidden="true"></span>
                                    </span>
                                    <input type="text" value={this.state.email} onChange={this.changeEmail} className="form-control" placeholder="Email" />
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                    <button type="button" onClick={(e) => {e.stopPropagation(); this.sendTest()}} className="btn-block btn btn-dark"><i className="icon wb-check" aria-hidden="true"></i> Send test</button>
                                </div>
                            </div>
                            </div>
                        </div>



                            <div className="col-sm-12">
                               
                            <div className="panel panel-bordered" style={{border:' 1px solid #e4eaec'}}>
                            <div className="panel-body"> 
                            <div className="col-sm-12">
                                <div className="btn-group col-sm-12" aria-label="Default button group" role="group">
                                    <a href="javascript:void(0)" onClick={(e) => this.switch('desktop') } className={`col-sm-6 btn btn-outline btn-default ${(this.state.mode == 'desktop'?'current':null)}`}>Desktop</a>
                                    <a href="javascript:void(0)" onClick={(e) => this.switch('mobile') } className={`col-sm-6 btn btn-outline btn-default ${(this.state.mode == 'mobile'?'current':null)}`}>Mobile</a>
                                </div><div className="clearfix"></div>
                            </div>
                            </div></div>
                            <div className="clearfix"></div>
                           {this.preview()}
                           <div className="clearfix"></div>
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    }

  
}

export default Preview;






// WEBPACK FOOTER //
// ./components/builder/Preview.js